import { useEffect, useState } from 'react';
import { Modal } from '../../../theme/Component/Modal';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { toast } from 'react-toastify';
import { BasicTable } from '../../../theme/Component/BasicTable';
import { _BudgetActivity } from '../../../../core/services/dataBean/EntityCatalogVdos';
import { BasicButton } from '../../../theme/Component/BasicButton';
import useModal, { MODAL_XL } from '../../../theme/Component/hooks/useModal';
import usePaginator from '../../../theme/Component/usePaginator';

interface Props {
    idSelector?: number | null;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const EditorBudgetActivity = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_BudgetActivity);
    const paginador = usePaginator();

    const [text, setText] = useState<string>("");
    const [regexStr, setregexStr] = useState<string>("");

    const modal = useModal("Actividades Presupuestales", MODAL_XL);

    useEffect(() => {
        if (!idSelector && !render) {
            setText("");
        }
    }, [idSelector, render])

    useEffect(() => {
        if (render) {
            setText(render);
        }
    }, [render])

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {
        instance.getBudgetActivityCatalog(regexStr ? regexStr : null, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15);
                    setLista(resp.List);
                }
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const getText = (item: any) => {
        return [item?.IDBudgetActivity, item?.Name].filter(Boolean).join(" - ");
    }

    const head = [
        { title: 'ID', property: 'IDBudgetActivity', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripcion', property: 'Description', visible: true },
    ]

    const setValue = (item: any) => {
        const selectedId = Number(item?.IDBudgetActivity);

        if (!selectedId) {
            onChange(returnType === "Object" ? {} : null);
            toast.error("Actividad presupuestal no valida");
            return;
        }

        if (onChange) {
            onChange(returnType === "Object" ? item : selectedId);
        }

        setText(getText(item));
        modal.close();
    };

    return (
        <>
            <label>{label ?? "Actividad Presupuestal"}</label>
            <div className="form-control text-wrap" style={{ minHeight: '35px' }} onClick={() => { modal.open() }}>
                {text ? text : (
                    <span>Seleccionar...</span>
                )}
            </div>

            <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { setValue(bean) }}>
                <div className="row">
                    <div className="col-md-6">
                        <label>Busqueda por Texto</label>
                        <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                    </div>
                    <div className="col-md-6 mt-4 p-2">
                        <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                    </div>
                    <div className="col-md-12">
                        <BasicTable body={lista} head={head} rowSet={setBean} records={paginador} customRows={15} />
                    </div>
                </div>
            </Modal>
        </>
    )
}
